import {
  LISTING_TYPES,
  MERCHANDISE_SHIPPING_STATUS,
} from "../../../../Offerings/constants/Offering.constants";
import { MERCHANDISE_DISPATCH_STATUS } from "../../../../Offerings/modules/Merchandise/Merchandise.constants";

export const DEFAULT_COVER_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/scoot-staging-572e7.appspot.com/o/000000000000000000000_event_images%2Fcategory%2Fdefault%2Ftes.jpeg?alt=media&token=a4cb0783-5e41-4443-892f-7cafbdc9b201";

export const OFFERING_CARD_TIMESTAMP_FORMAT = "EEEE, dd MMM yyyy | hh:mm a";

export const SHIPPING_STATUS_BASED_PROPS: {
  [k: number]: { TITLE: string; COLOR: string };
} = {
  [MERCHANDISE_SHIPPING_STATUS.PENDING]: {
    TITLE: "Packing",
    COLOR: "#FFBA00",
  },
  [MERCHANDISE_SHIPPING_STATUS.NOT_AVAILABLE]: {
    TITLE: "Packing",
    COLOR: "#E94235",
  },
  [MERCHANDISE_SHIPPING_STATUS.DISPATCHED]: {
    TITLE: "Shipped",
    COLOR: "#FFBA00",
  },
  [MERCHANDISE_SHIPPING_STATUS.DELIVERED]: {
    TITLE: "Delivered",
    COLOR: "#00CC88",
  },
};

export const ALL_OFFERINGS_TYPES_ITEM = {
  value: "all",
  label: "All",
};

export const BOOKINGS_LIST_API_KEY = "bookings";

export const BOOKINGS_STAGES = {
  UPCOMING: {
    value: "1",
    label: "Upcoming",
  },
  NOT_STARTED: {
    value: "1",
    label: "Not Started",
  },
  IN_PROGRESS: {
    value: "2",
    label: "In Progress",
  },
  IN_TRANSIT: {
    value: "2",
    label: "In Transit",
  },
  DELIVERED: {
    value: "3",
    label: "Delivered",
  },
  COMPLETED: {
    value: "3",
    label: "Completed",
  },
};

export const BOOKINGS_STAGES_DETAILS = {
  [LISTING_TYPES.APPOINTMENTS]: [
    BOOKINGS_STAGES.UPCOMING,
    BOOKINGS_STAGES.IN_PROGRESS,
    BOOKINGS_STAGES.COMPLETED,
  ],
  [LISTING_TYPES.WORKSHOPS]: [
    BOOKINGS_STAGES.UPCOMING,
    BOOKINGS_STAGES.IN_PROGRESS,
    BOOKINGS_STAGES.COMPLETED,
  ],
  [LISTING_TYPES.RECORDED_CONTENT]: [
    BOOKINGS_STAGES.NOT_STARTED,
    BOOKINGS_STAGES.IN_PROGRESS,
    BOOKINGS_STAGES.COMPLETED,
  ],
  [LISTING_TYPES.ONE_ON_ONE_CLASSES]: [
    BOOKINGS_STAGES.UPCOMING,
    BOOKINGS_STAGES.IN_PROGRESS,
    BOOKINGS_STAGES.COMPLETED,
  ],
  [LISTING_TYPES.WEBINAR]: [
    BOOKINGS_STAGES.UPCOMING,
    BOOKINGS_STAGES.COMPLETED,
  ],
  [LISTING_TYPES.MERCHANDISE]: [
    BOOKINGS_STAGES.IN_TRANSIT,
    BOOKINGS_STAGES.DELIVERED,
  ],
};

export const BOOKINGS_DETAILS_MODAL_SKU_MAP = {
  [LISTING_TYPES.APPOINTMENTS]: {
    title: "Appointments",
    color: "#FF5D8F",
  },
  [LISTING_TYPES.ONE_ON_ONE_CLASSES]: {
    title: "Class",
    color: "#0096C7",
  },
  [LISTING_TYPES.GROUP_CLASSES]: { title: "Class", color: "#0096C7" },
  [LISTING_TYPES.WORKSHOPS]: { title: "Workshop", color: "#46A58A" },
  [LISTING_TYPES.NO_SCHEDULE]: { title: "Payment Page", color: "#577590" },
  [LISTING_TYPES.RECORDED_CONTENT]: {
    title: "Recorded Content",
    color: "#F68391",
  },
  [LISTING_TYPES.MERCHANDISE]: {
    [`${MERCHANDISE_DISPATCH_STATUS.PENDING}`]: {
      TITLE: "Packing",
      COLOR: "#FFBA00",
    },
    [`${MERCHANDISE_DISPATCH_STATUS.DISPATCHED}`]: {
      TITLE: "Shipped",
      COLOR: "#FFBA00",
    },
    [`${MERCHANDISE_DISPATCH_STATUS.DELIVERED}`]: {
      TITLE: "Delivered",
      COLOR: "#00CC88",
    },
  },
  [LISTING_TYPES.ROLLING_CLASSES]: {
    title: "Class",
    color: "#0096C7",
  },
  [LISTING_TYPES.TELEGRAM]: { title: "Telegram Community", color: "" },
  [LISTING_TYPES.WEBINAR]: { title: "Webinars", color: "#F3722C" },
  [LISTING_TYPES.WHATSAPP]: { title: "Community", color: "" },
  [LISTING_TYPES.BRANDED_COMMUNITY]: { title: "Branded Communityt", color: "" },
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 0,
  PENDING: 1,
  HALTED: 2,
  CANCELLED: 3,
  COMPLETED: 4,
  FAILED: 5,
  ON_HOLD: 22,
};

export const TELEGRAM_LINK_STATUS = {
  PENDING_LINK_GENERATION: 1,
  INVITE_GENERATED_JOINING_PENDING: 2,
  JOINED: 3,
  INVITE_EXPIRED: 4,
  GROUP_EXIT: 5,
  ERROR_GENERATING_LINK: 6,
};

export const TELEGRAM_LINK_ERROR_MSG = {
  [TELEGRAM_LINK_STATUS.PENDING_LINK_GENERATION]:
    "Telegram community link generation pending",
  [TELEGRAM_LINK_STATUS.INVITE_EXPIRED]:
    "Telegram community link invite has expired",
  [TELEGRAM_LINK_STATUS.GROUP_EXIT]: "Telegram community group has been exited",
  [TELEGRAM_LINK_STATUS.ERROR_GENERATING_LINK]:
    "Error in generating telegram community link",
};
